<script setup>
import { watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useHead } from '@unhead/vue';
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
import Helpers from '@/helpers/index.js';
import { useQuery } from '@tanstack/vue-query';
import { useAppStore } from '@/stores/app.store.js';
import AppLoader from '@/components/Loaders/AppLoader.vue';

const route = useRoute();
// const isAppLoading = computed(() => useAppStore().isAppLoading);

useHead({
  titleTemplate: (title) => (!title ? 'PartnrUp' : `PartnrUp - ${title}`)
});

// // const app = useAppStore();
// // // const loadingScreen = useLoadingStore();
// //
// // const { isLoading, error } = useQuery({
// //   queryKey: ['loadAppData'],
// //   queryFn: app.init,
// //   enabled: Helpers.isAuth(),
// //   refetchOnWindowFocus: false
// // });
//
// watchEffect(() => {
//   if (Helpers.isAuth()) {
//     useAppStore().init();
//   }
// });
</script>

<template>
  <!--  <template v-if="isAppLoading">-->
  <!--    <AppLoader />-->
  <!--  </template>-->
  <!--  <template v-else>-->
  <!--    <RouterView />-->
  <!--  </template>-->
  <component :is="route.meta.layoutComponent">
    <RouterView />
  </component>
  <VueQueryDevtools />
</template>

<style lang="scss" scoped>
// @import '@/assets/css/app.scss';
//
</style>
